import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  acceptDisclaimer,
  getThreadId,
  sendFeedback,
  sendRequest,
  getDisclaimer,
} from '@services'
import {
  ChatbotConversation,
  ChatbotDialogRequest,
  ChatbotFeedbackRequest,
} from '@interfaces'

export const clearConversation = createAction('clearConversation')
export const addConversation = createAction<string, 'addConversation'>(
  'addConversation',
)
export const resetErrorMessage = createAction<void, 'resetErrorMessage'>(
  'resetErrorMessage',
)

export const fetchThreadId = createAsyncThunk<{ id: string }>(
  'getThreadId',
  async () => getThreadId(),
)

export const sendChatRequest = createAsyncThunk<
  ChatbotConversation,
  ChatbotDialogRequest
>('sendRequest', async ({ id, request, signal }) =>
  sendRequest(id, request, signal),
)

export const cancelRequest = createAction<'cancelRequest'>('cancelRequest')
export const sendMsgFeedback = createAsyncThunk<void, ChatbotFeedbackRequest>(
  'sendFeedback',
  async ({ id, messageId, status }) => sendFeedback(id, messageId, status),
)

export const acceptDisclaimerNote = createAsyncThunk<boolean, void>(
  'acceptDisclaimer',
  async () => acceptDisclaimer(),
)

export const getDisclaimerNote = createAsyncThunk<boolean, string>(
  'getDisclaimer',
  async (customerId) => getDisclaimer(customerId),
)
